export default __webpack_public_path__ + "53c4fd17485c95f6a8a796c05c8cb797.png";